import { isBrowser } from './browserDetector';
import serverLog from './serverLog';

// ##### Komarov 2026-06-01
const getDateTime = () => {
  return new Date()
    .toLocaleString('sv-SE', { timeZone: 'Europe/Kyiv' })
    .replace(',', '');
}

// ##### Komarov 2025-08-20
export const uniLog = (...args) => {
  // ##### Best Practice: Always log to console for measuring, both client and server
  const title = args[0];
  const data = args.slice(1);
  if (process.env.NODE_ENV === 'development') {
    if (isBrowser) {
      // ##### Komarov 2026-06-01: Show logs in browser console
      console.info(`[CLIENT] [${getDateTime()}]`, title, ...data);
    } else {
      // ##### Komarov 2026-06-01: Log to server console
      console.info(`[SERVER] [${getDateTime()}]`, title, ...data);
      serverLog(args); // Retain existing data recording if needed
    }
  }
};
